import { useQuery } from '@tanstack/react-query'
import {
	type GetVisualVettingAccuracyParams,
	httpGetVisualVettingAccuracy
} from '@/features/luxe-submissions/http/luxe-submissions.http'

export const VISUAL_VETTING_ACCURACY_QUERY_KEY = 'visual-vetting-accuracy'

export const useGetVisualVettingAccuracy = (
	params: GetVisualVettingAccuracyParams
) =>
	useQuery({
		queryKey: [VISUAL_VETTING_ACCURACY_QUERY_KEY, params],
		queryFn: () => httpGetVisualVettingAccuracy(params)
	})
